<template>
  <div class="app-container">
    <list ref="list">
      
    
    </list>
   
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/facility/equipment/warmdata/list'


export default {
  mixins: [curdMixins],
  components: {
    list,
   
  },
  data(){
    return {
      type: 0,
    }
  },
  methods: {
    delRows(){
      this.$refs.list._del();
    },
    _create(){
      this.type = 0;
      this.create();
    },
    _edit(row){
      this.type = 1;
      this.edit(row);
    }
  }
  
};
</script>